import config from 'frontend/config/environment';

interface ListItemBreadCrumb {
  '@type': string;
  position: number;
  name: string;
  item: string;
}

export default function buildBreadcrumb(url: string, title?: string) {
  const rootBreadcrumb: ListItemBreadCrumb = {
    '@type': 'ListItem',
    position: 1,
    name: 'Accueil',
    item: config.frontUrl,
  };
  const urlParts = url.split('//')[1]?.split('?')[0]?.split('/').slice(1);
  if (urlParts?.includes('catalogue') && !urlParts?.includes('action')) {
    const catalogueBreadcrumb = {
      '@type': 'ListItem',
      position: 2,
      name: 'Catalogue',
      item: `${config.frontUrl}/catalogue`,
    };
    if (urlParts?.length === 1) {
      return [rootBreadcrumb, catalogueBreadcrumb];
    }
    if (urlParts?.length === 3) {
      return [
        rootBreadcrumb,
        catalogueBreadcrumb,
        {
          '@type': 'ListItem',
          position: 3,
          name: title,
          item: url,
        },
      ];
    }
  } else {
    if (urlParts?.length) {
      return [
        rootBreadcrumb,
        {
          '@type': 'ListItem',
          position: 2,
          name: title,
          item: url,
        },
      ];
    }
  }
  return [rootBreadcrumb];
}
